export default {
  default: () => import("/vercel/path0/layouts/default.vue").then(m => m.default || m),
  gallery: () => import("/vercel/path0/layouts/gallery.vue").then(m => m.default || m),
  note: () => import("/vercel/path0/layouts/note.vue").then(m => m.default || m),
  "note-full": () => import("/vercel/path0/layouts/noteFull.vue").then(m => m.default || m),
  "old-note": () => import("/vercel/path0/layouts/old_note.vue").then(m => m.default || m),
  page: () => import("/vercel/path0/node_modules/@nuxt-themes/docus/layouts/page.vue").then(m => m.default || m)
}